import Vue from 'vue'
import axios from 'axios'
import { Message } from 'element-ui'
axios.defaults.baseURL = VUE_APP_BASE_API;
axios.defaults.timeout = 8000;

axios.interceptors.request.use(config => {
  const token = sessionStorage.getItem('token');
  if(token){
    // config.params = {'X-Token':token} //如果要求携带在参数中
    
    config.headers = {
      // 'hb-Token':token, //配置请求头
      'Content-Type':'application/json;charset=UTF-8'
    }
  }else{
    config.headers = {
      'Content-Type':'application/json;charset=UTF-8'
    }
  }
  return config
}, error => {
  Promise.reject(error)
})
// 3.响应拦截器
axios.interceptors.response.use(response => {
  if(response.status==200){
    return response.data
  }else {
    return Promise.reject(response)
  }
}, error => {
  if (error.response) {
    console.log(error.response.status)
    // switch (error.response.status){
    //   case 500:
    //     Message({
    //       message: '登录过期，请重新登录！',
    //       type: 'error'
    //     });
    //     sessionStorage.removeItem('token');
    //     location.href = '/login'
    //     break;
    //   case 401:
    //     sessionStorage.removeItem('token');
    //     location.href = '/login'
    //     break;
    //   default:
    //     Message({
    //       message: '系统异常，请联系管理员！',
    //       type: 'error'
    //     });
    // }
  } else {
    Message({
      message: '服务器连接失败！',
      type: 'error'
    });
  }
  return Promise.reject(error);
})
//4.导入文件
export default axios